import { Box } from '@mui/material';
import { KitButton, KitList, SecH } from '../common/MobileKit';
import MobileSheet from '../common/MobileSheet';
import { protoIcon } from '../common/ProtoIcon';
import { KitField, KitFormBar, KitInput, KitSeg, KitTextarea } from '../common/MobileKitExtras';
import { MobileListRow } from '../common/MobileCrud';

/**
 * Formulário de categoria no shell mobile — `prototipos-mobile/categorias/form.html`.
 * Só apresentação: valores, validação, subcategorias e envio vêm de `pages/categories/Form.js`.
 */

const GridIcon = protoIcon('grid');
const PlusIcon = protoIcon('plus');

export default function MobileCategoryForm({
    isEdit,
    isProduto,
    onTypeChange,
    name,
    onNameChange,
    nameError,
    description,
    onDescriptionChange,
    margin,
    onMarginChange,
    marginError,
    subcategories,
    onNewSub,
    onEditSub,
    sub,
    onCancel,
    onSave,
    saving,
    loading,
}) {
    return (
        <Box sx={{ fontSize: 14, lineHeight: 1.4 }} component="form" onSubmit={(e) => { e.preventDefault(); onSave(); }} noValidate>
            {!isEdit && (
                <KitField label="Tipo" required>
                    <KitSeg
                        options={[{ value: 'produto', label: 'Produto' }, { value: 'servico', label: 'Serviço' }]}
                        value={isProduto ? 'produto' : 'servico'}
                        onChange={onTypeChange}
                    />
                </KitField>
            )}

            <KitField label="Nome da categoria" required help={nameError || undefined} error={Boolean(nameError)}>
                <KitInput
                    type="text"
                    value={name}
                    onChange={(e) => onNameChange(e.target.value)}
                    placeholder="Ex.: Freios"
                    maxLength={255}
                    error={Boolean(nameError)}
                    disabled={loading}
                />
            </KitField>

            <KitField label="Descrição">
                <KitTextarea value={description} onChange={(e) => onDescriptionChange(e.target.value)} maxLength={255} disabled={loading} />
            </KitField>

            {isProduto && (
                <KitField
                    label="Margem de lucro (%)"
                    help={marginError || 'Opcional — sugere o preço de venda ao cadastrar produtos'}
                    error={Boolean(marginError)}
                >
                    <KitInput
                        type="text"
                        inputMode="decimal"
                        value={margin}
                        onChange={(e) => onMarginChange(e.target.value)}
                        error={Boolean(marginError)}
                        disabled={loading}
                    />
                </KitField>
            )}

            <SecH title="Subcategorias" />
            {isEdit && subcategories.length > 0 && (
                <KitList>
                    {subcategories.map((item) => (
                        <MobileListRow
                            key={item.id}
                            icon={GridIcon}
                            title={item.name}
                            sub={isProduto && item.profit_margin !== null && item.profit_margin !== undefined ? `margem ${item.profit_margin}%` : undefined}
                            chevron
                            onClick={() => onEditSub(item)}
                        />
                    ))}
                </KitList>
            )}
            {!isEdit && (
                <Box sx={{ fontSize: 12, color: 'text.disabled', m: '0 2px', lineHeight: 1.4 }}>Salve a categoria para cadastrar subcategorias.</Box>
            )}
            {isEdit && subcategories.length === 0 && !loading && (
                <Box sx={{ fontSize: 12, color: 'text.disabled', m: '0 2px', lineHeight: 1.4 }}>Nenhuma subcategoria cadastrada.</Box>
            )}
            <KitButton variant="soft" block sx={{ mt: '12px' }} onClick={onNewSub} disabled={!isEdit}>
                <PlusIcon size={18} /> Adicionar subcategoria
            </KitButton>

            <KitFormBar>
                <KitButton onClick={onCancel}>Cancelar</KitButton>
                <KitButton variant="primary" onClick={onSave} disabled={saving || loading}>
                    {saving ? 'Salvando...' : 'Salvar'}
                </KitButton>
            </KitFormBar>

            <MobileSheet
                open={sub.open}
                onClose={sub.onClose}
                title={sub.editing ? 'Editar subcategoria' : 'Nova subcategoria'}
                footer={(
                    <>
                        <KitButton sx={{ flex: 1 }} onClick={sub.onClose}>Cancelar</KitButton>
                        <KitButton variant="primary" sx={{ flex: 1 }} onClick={sub.onSave} disabled={sub.saving}>
                            {sub.saving ? 'Salvando...' : 'Salvar'}
                        </KitButton>
                    </>
                )}
            >
                <KitField label="Nome da subcategoria" required help={sub.nameError || undefined} error={Boolean(sub.nameError)}>
                    <KitInput type="text" value={sub.name} onChange={(e) => sub.onNameChange(e.target.value)} maxLength={255} error={Boolean(sub.nameError)} />
                </KitField>
                {isProduto && (
                    <KitField label="Margem de lucro (%)" help={sub.marginError || undefined} error={Boolean(sub.marginError)}>
                        <KitInput type="text" inputMode="decimal" value={sub.margin} onChange={(e) => sub.onMarginChange(e.target.value)} error={Boolean(sub.marginError)} />
                    </KitField>
                )}
                {sub.editing && (
                    <KitButton variant="danger" block onClick={sub.onDelete}>Excluir subcategoria</KitButton>
                )}
            </MobileSheet>
        </Box>
    );
}
